import { render } from "./add-group.vue?vue&type=template&id=94833808&scoped=true"
import script from "./add-group.vue?vue&type=script&lang=js"
export * from "./add-group.vue?vue&type=script&lang=js"

import "@/resources/css/settings.scss?vue&type=style&index=0&id=94833808&lang=scss&scoped=true&external"
import "./add-group.vue?vue&type=style&index=1&id=94833808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94833808"]])

export default __exports__